import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["item", "group", "empty", "query", "list"];

  connect() {
    if (this.hasQueryTarget) this.filter();
  }

  listTargetConnected() {
    if (this.hasQueryTarget) this.filter();
  }

  filter(event) {
    const query = (this.hasQueryTarget ? this.queryTarget : event.target).value
      .toLowerCase()
      .trim();

    this.itemTargets.forEach((item) => {
      item.classList.toggle("hidden", !item.dataset.filterText.includes(query));
    });

    const visibleItems = this.itemTargets.filter(
      (item) => !item.classList.contains("hidden"),
    );

    this.groupTargets.forEach((group) => {
      group.classList.toggle(
        "hidden",
        visibleItems.every((item) => !group.contains(item)),
      );
    });

    if (this.hasEmptyTarget) {
      this.emptyTarget.classList.toggle("hidden", visibleItems.length > 0);
    }
  }
}
